module.exports = __webpack_public_path__ + "static/img/cfns_logo.95d779c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cfns_logo.png
// module id = 543
// module chunks = 0